import { render, staticRenderFns } from "./ReferenceAddButton.vue?vue&type=template&id=245f8e02"
import script from "./ReferenceAddButton.vue?vue&type=script&lang=js"
export * from "./ReferenceAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports